<template>
  <div class="content">
    <h1>Uzņēmumi</h1>
    <TableContent
      :table-info="userTableInfo"
      name="companies"
      redirect="company/courses/"
    ></TableContent>
  </div>
</template>

<script>
import TableContent from "@/Admin/components/TableContent.vue";
import RedirectToCompanyCoursesAction from "@/Admin/components/form_actions/RedirectToCompanyCoursesAction.vue";
import DeleteAction from "@/Admin/components/form_actions/DeleteAction.vue";
import EditAction from "@/Admin/components/form_actions/EditAction.vue";

export default {
  name: "CompaniesListView",
  components: { TableContent },
  data: () => ({
    userTableInfo: {
      headers: [
        {
          title: "Nosaukums",
          align: "start",
          key: "name",
        },
        {
          title: "Reģistrācijas nr.",
          align: "start",
          key: "registration_number",
        },
        {
          title: "Darbības",
          align: "start",
          sortable: false,
          key: "actions",
        },
      ],
      actions: [EditAction, DeleteAction, RedirectToCompanyCoursesAction],
    },
  }),
};
</script>

<style scoped>
.content {
  width: 100%;
}
</style>
